import Container from "react-bootstrap/Container";
import BreadCrumb from "../../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../../components/organisms/Headline/Headline";
import NewLeadTemplate from "../../../../components/templates/NewLeadTemplate/NewLeadTemplate";

const NewLead = () => (
  <Container fluid className="layout-bar">
    <BreadCrumb />
    <Headline
      name="Add new lead"
      subHeading="Capture lead information to get started"
    />
    <NewLeadTemplate />
  </Container>
);

export default NewLead;
